import React, { FC } from 'react';
import { HealthCheckupInstitution } from '../../query';
import { DeleteHealthCheckupInstitution } from '../DeleteHealthCheckupInstitution';
import { Link } from 'react-router-dom';
import { Edit } from 'jbc-front/components/icons';
import { Description } from '../Description';
import styles from './HealthCheckupInstitutionsTable.scss';

interface RowProps {
  healthCheckupInstitution: HealthCheckupInstitution;
  refetch: () => void;
}

export const Row: FC<RowProps> = ({ healthCheckupInstitution, refetch }) => {
  return (
    <tr className={styles.row}>
      <td>{healthCheckupInstitution.healthCheckupInstitutionId}</td>
      <td>{healthCheckupInstitution.name}</td>
      <td>{healthCheckupInstitution.location}</td>
      <td className={styles.iconContainer}>
        <div className={styles.noteWrap}>
          <div className={styles.noteLarge}>
            <Description text="編集">
              <Link
                className={styles.icon}
                to={`/settings/health_checkup_institution/edit/${healthCheckupInstitution.id}`}>
                <Edit size={20} />
              </Link>
            </Description>
          </div>
          <div className={styles.noteLarge}>
            <DeleteHealthCheckupInstitution
              healthCheckupInstitution={healthCheckupInstitution}
              refetch={refetch}
              className={styles.icon}
            />
          </div>
        </div>
      </td>
    </tr>
  );
};
